import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogCreaCarga } from './crear-carga.component';
import { DialogEditaCarga } from './edita-carga.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { MantenedorCargasService } from 'src/app/services/mantenedor-cargas/mantenedor-cargas.service';
import Swal from 'sweetalert2';
declare const Rut: any;

@Component({
    selector: 'app-mantenedor-cargas',
    templateUrl: '../../pages/mantenedor-cargas/mantenedor-cargas.component.html',
    styleUrls: ['../../pages/mantenedor-cargas/mantenedor-cargas.component.css']
})
export class MantenedorCargasComponent implements OnInit {
    rol: string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")

    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
    usuarios: any
    cargas: any
    cargasFinales: any
    correo: any = ""
    rut: any = ""
    rutTitular: any = ""
    termino: string = "";

    constructor(private dialog: MatDialog, private mantenedorService: MantenedorCargasService) { }

    ngOnInit(): void { this.loadData() }

    loadData() {
        let vm = this

        this.mantenedorService.traeCargasMuestra().then
            (
                (cargas: any) => {
                    console.log(cargas)

                    vm.cargas = cargas
                    vm.cargasFinales = cargas

                    vm.config.totalItems = cargas.length
                }
            )
            .catch(error => {
                console.log(error)

                vm.openAlertDialog("No hay registros disponibles.", "btn-danger")
            })
    }


    /*  buscar()
      { 
          if(this.rut != "" && this.rut.split('-')[0] !="") 
          {  
              this.cargasFinales = this.cargas.filter( car => car.rut == this.rut.split('-')[0] )
          }   else { 
              this.cargasFinales = this.cargas        
          }
          
          this.config.totalItems = this.cargasFinales.length
          this.config.currentPage = 1
      }*/


    buscar() {
        let vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        let rut = "";
        let dv = "";
        let rutEnvio = "0";
        let rutEnvioTitular = "0";
        /*
        if (vm.rut && !Rut(vm.rut)) {
            Swal.close();
            this.openAlertDialog('El rut no tiene un formato válido', 'btn-dark')
            return false
        }

        if (vm.rut && vm.rut != "" && !vm.rut.includes("-")) {
            Swal.close();
            this.openAlertDialog('El rut no tiene un formato válido', 'btn-dark')
            return false
        }*/

        if (vm.rut && vm.rut.includes("-")) {
            dv = vm.rut.split('-')[1];
            rutEnvio = vm.rut.split('-')[0];
            if (!dv) {
                Swal.close();
                this.openAlertDialog('El rut no tiene un formato válido', 'btn-dark')
                return false
            }
        }else{
            rutEnvio = vm.rut
        }
        /*
        if (vm.rutTitular && !Rut(vm.rutTitular)) {
            Swal.close();
            this.openAlertDialog('El rut del titular no tiene un formato válido', 'btn-dark')
            return false
        }

        if (vm.rutTitular && vm.rutTitular != "" && !vm.rutTitular.includes("-")) {
            Swal.close();
            this.openAlertDialog('El rut del titular no tiene un formato válido', 'btn-dark')
            return false
        }*/

        if (vm.rutTitular && vm.rutTitular.includes("-")) {
            dv = vm.rutTitular.split('-')[1];
            rutEnvioTitular = vm.rutTitular.split('-')[0];
            if (!dv) {
                Swal.close();
                this.openAlertDialog('El rut del titular no tiene un formato válido', 'btn-dark')
                return false
            }
        }else{
            rutEnvioTitular = vm.rutTitular
        }



        this.mantenedorService.cargasBuscador(rutEnvio, rutEnvioTitular).then
            (
                (cargas: any) => {
                    console.log(cargas)
                    vm.cargasFinales = cargas
                    Swal.close();
                    vm.config.totalItems = cargas.length
                }
            )
            .catch(error => {
                console.log(error)
                Swal.close();
                vm.cargasFinales = []
                vm.openAlertDialog("No hay registros disponibles.", "btn-danger")
            })
    }

    crearCarga() {
        let vm = this
        let data: any = {}

        const dialogRef = this.dialog.open(DialogCreaCarga, { disableClose: true, data: data, width: '40%' })

        dialogRef.afterClosed().subscribe(() => {
            if (data.recarga) {
                vm.cargasFinales = []
                vm.loadData()
            }
        })
    }


    editarCarga(idCarga: any) {
        let vm = this
        let data: any = {}

        data.sexos = [{ id: 1, descripcion: 'Hombre' }, { id: 2, descripcion: 'Mujer' }]

        this.mantenedorService.traerCarga(idCarga).then
            (
                (carga: any) => {
                    data.fechaCreacion = carga.fechaCreacion.split('-').length > 0 ?
                        carga.fechaCreacion.split('-')[2] + '-' + carga.fechaCreacion.split('-')[1] + '-' + carga.fechaCreacion.split('-')[0] : ''
                    if (carga.fechaNacimiento) {
                        let fechaNacimiento = carga.fechaNacimiento.split('-')[2] + '-' + carga.fechaNacimiento.split('-')[1] + '-' + carga.fechaNacimiento.split('-')[0]
                        carga.fechaNacimiento = fechaNacimiento
                        data.fechaNacimiento = fechaNacimiento
                    } else {
                        carga.fechaNacimiento = []
                    }

                    if (carga.fechaCreacion) {
                        let fechaCreacion = carga.fechaCreacion.split('-')[2] + '-' + carga.fechaCreacion.split('-')[1] + '-' + carga.fechaCreacion.split('-')[0]
                        carga.fechaCreacion = fechaCreacion
                        data.fechaCreacion = fechaCreacion
                    } else {
                        carga.fechaCreacion = []
                    }

                    if (carga.fechaDefuncion) {
                        let fechaDefuncion = carga.fechaDefuncion.split('-')[2] + '-' + carga.fechaDefuncion.split('-')[1] + '-' + carga.fechaDefuncion.split('-')[0]
                        carga.fechaDefuncion = fechaDefuncion
                        data.fechaDefuncion = fechaDefuncion
                    } else {
                        carga.fechaDefuncion = []
                    }

                    if (carga.fechaExpiracion) {
                        let fechaExpiracion = carga.fechaExpiracion.split('-')[2] + '-' + carga.fechaExpiracion.split('-')[1] + '-' + carga.fechaExpiracion.split('-')[0]
                        carga.fechaExpiracion = fechaExpiracion
                        data.fechaExpiracion = fechaExpiracion
                    } else {
                        carga.fechaExpiracion = []
                    }

                    data.carga = carga

                    const dialogRef = this.dialog.open(DialogEditaCarga, {
                        disableClose: true, width: '40%', data: data
                    })

                    dialogRef.afterClosed().subscribe(() => {
                        if (data.recarga) {
                            vm.cargasFinales = []
                            vm.loadData()
                        }
                    })
                }
            )
            .catch(error => {
                console.log(error)

                vm.openAlertDialog("Ha ocurrido un error al traer los datos del usuario!", "btn-danger")
            })
    }

    modificarEstadoCarga(idUsuario: any, estado: any) {
        let vm = this

        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de cambiar el estado de la Carga?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                if (estado == 'AFILIADO') { estado = 'DESAFILIADO' }

                else { estado = 'AFILIADO' }

                vm.mantenedorService.modificarEstado(idUsuario, estado).then
                    (
                        () => {
                            vm.openAlertDialog("Se ha modificado exitosamente el estado de la carga.", "btn-success")

                            dialogRef.close()
                            vm.loadData()
                        }
                    )
                    .catch(error => {
                        console.log(error)

                        vm.openAlertDialog("Ha ocurrido un error al modificar la carga.", "btn-danger")

                        dialogRef.close()
                    })
            }
        })
    }

    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent,
            {
                data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' } }
            })
    }

    pageChanged(event: any) {
        this.config.currentPage = event

        this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
    }

    cambiaCantidadRegistros() {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1
    }
}